import React from "react";
import { ITickets } from "../../containers/Tickets/types";

interface DragPreviewPortalProps {
  ticket: ITickets;
  count: number;
  renderPreview?: (ticket: ITickets) => React.ReactNode;
}

export function DragPreview({
  ticket,
  count,
  renderPreview,
}: DragPreviewPortalProps) {
  return (
    <div
      style={{
        position: "relative",
        display: "inline-flex",
        fontFamily: "inherit",
        cursor: "pointer",
      }}
    >
      {/* Main card */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          background: "#ffffff",
          border: "1px solid #e5e7eb",
          borderRadius: 8,
          padding: "6px 12px",
          boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
          minWidth: 220,
          maxWidth: 340,
          cursor: "pointer",
        }}
      >
        {/* Blue checked checkbox */}
        <div
          style={{
            width: 16,
            height: 16,
            flexShrink: 0,
            borderRadius: 4,
            background: "#2563eb",
            border: "1px solid #2563eb",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
            <path
              d="M1 3.5L3.5 6.5L9 1"
              stroke="#fff"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* Ticket name or custom preview */}
        {renderPreview ? (
          renderPreview(ticket)
        ) : (
          <span
            style={{
              fontSize: 13,
              color: "#111827",
              fontWeight: 400,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              flex: 1,
            }}
          >
            {ticket.ticketName ?? ticket.ticketID}
          </span>
        )}
      </div>

      {/* Count badge — only when multi-select */}
      {count > 1 && (
        <div
          style={{
            position: "absolute",
            top: -8,
            right: -8,
            zIndex: 10,
            minWidth: 20,
            height: 20,
            borderRadius: 10,
            background: "#2563eb",
            color: "#fff",
            fontSize: 11,
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingInline: 5,
            boxShadow: "0 2px 6px rgba(37,99,235,0.35)",
            border: "2px solid #fff",
          }}
        >
          {count}
        </div>
      )}
    </div>
  );
}
